<template>
  <div class="download">
    <banner img="../assets/img/appDown.jpg" title="下载APP" />
    <div class="case" v-loading="loading">
      <div class="case-content">
        <div class="page">
          <h3>App下载</h3>
          <p>App Download</p>
        </div>
          <ul>
            <li>
              <h3>公众号下载</h3>
              <div class="Imgs">
                <img src="../assets/img/ercode.jpg" alt="">
              </div>
            </li>
            <li>
              <h3>应用宝下载</h3>
              <div class="Imgs">
                <img src="../assets/img/YYB_DownLoad.png" alt="">
              </div>
            </li>
            <li>
              <h3>AppStore下载</h3>
              <div class="Imgs">
                <img src="../assets/img/AppStoreDown.jpg" alt="">
              </div>
            </li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading:false
    }
  }
};
</script>

<style lang="scss" scoped>
img{
  width: 100%;
  height: 100%;
}
.download{
    .case {
    width: 100%;
    &-content {
      text-align: center;
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;
      .page{
        margin-top: 30px;
        font-size: 30px;
        P{
          margin-top: 10px;
          font-size: 15px;
          color: #999999;
        }
      }
      ul {
        padding: 30px 0;
        width: 1240px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        li{
          list-style: none;
          .Imgs{
            margin-top: 20px;
            width: 320px;
            height: 350px;
          }
        }
      }
    }
    
  }
}
</style>